


















































import ListItem from '@/components/list/ListItem.vue'
import Translation from '@/mixins/Translation'
import {Watch} from '@@/node_modules/vue-property-decorator'
import {Component, Mixins, Prop} from 'vue-property-decorator'
import BttPopup from '@/components/popup/btt/BttPopup.vue'
import {Input} from 'element-ui'
import {Client} from '@/store/modules/clients'

@Component({
  components: {ListItem, BttPopup, [Input.name]: Input},
})
export default class ClientFilterPopup extends Mixins(Translation) {
  @Prop({default: false, type: Boolean}) value: boolean
  @Prop({default: () => [], type: Array}) clients: Client[]
  @Prop({default: 'components.popup.client-filter-popup'}) translation: string
  @Prop({default: false, type: Boolean}) loadingClients: boolean
  @Prop({default: null, type: Number}) nextPage: null | number

  open: boolean = true
  searchKeyword: string = ''
  selectedClient: Client | null = null

  get isVisibleClients(): boolean {
    return Boolean(this.searchKeyword)
  }

  get clientsStyle(): object {
    const popupHeight = window.innerHeight * 0.8
    const headerHeight = 62
    const inputHeight = 46
    const extraPadding = 32 * 2
    return {
      maxHeight: `${popupHeight - (headerHeight + inputHeight + extraPadding)}px`,
    }
  }

  @Watch('value', {immediate: true})
  __value(value) {
    this.open = value
  }

  @Watch('open', {immediate: true})
  __open(value) {
    this.$emit('input', value)
    if(!value) {
      this.searchKeyword = ''
      this.$emit('clear-clients')
    }
  }

  @Watch('searchKeyword')
  __searchKeyword(value) {
    if(value) {
      this.$emit('clear-clients')
      this.$emit('get-clients', value)
    }
  }

  @Watch('isVisibleClients')
  __isVisibleClients(value) {
    if(value) {
      this.$nextTick(() => {
        const clientsEl: any = this.$refs.clients
        if(clientsEl) {
          clientsEl.$el.addEventListener('scroll', this.onScrollClients)
        }
      })
    }
  }

  destroyed() {
    const clientsEl: any = this.$refs.clients
    if(clientsEl) {
      clientsEl.$el.removeEventListener('scroll', this.onScrollClients)
    }
  }

  onClickClientItem(value) {
    this.selectedClient = value
    this.$emit('select-client', this.selectedClient)
    this.close()
  }

  onBlur() {
    const el: any = this.$refs['search-input']
    if(el) {
      el.blur()
    }
  }

  onScrollClients() {
    this.onBlur()
  }

  close() {
    this.open = false
  }

  onScroll() {
    if(this.nextPage !== null) {
      this.$emit('get-clients', this.searchKeyword)
    }
  }
}
